<template>
  <header class="ON_main_header" id="topOfPage">
    <div class="ON_main_top_menu">
      <div class="container">
        <div class="float-left">
          <a href="#">{{ currentDate }}</a>
        </div>
        <div class="float-right">
          <ul class="list ON_social_headers">
            <li>
              <a
                href="https://www.facebook.com/Objective-News-102027294866444/"
                target="_blank"
                ><i class="fa fa-facebook"></i
              ></a>
            </li>
            <li>
              <a href="https://twitter.com/ONews_Official" target="_blank"
                ><i class="fa fa-twitter"></i
              ></a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/objectivenews_official/"
                target="_blank"
                ><i class="fa fa-instagram"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="ON_main_logo">
      <div class="container">
        <div class="float-left">
          <router-link class="logo" to="/"
            ><img src="../assets/logo.png" width="300" height="100" alt=""
          /></router-link>
        </div>
        <div class="float-right">
          <div class="ON_header_ad">
            <div>
              <link
                href="https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext"
                rel="stylesheet"
              /><a
                class="bmc-button"
                target="_blank"
                href="https://www.buymeacoffee.com/objectiveNews"
                ><img
                  src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
                  alt="Buy us a coffee"
                /><span style="margin-left:5px;font-size:19px !important;"
                  >Buy us a coffee</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ON_main_ON_main_menu_navigation">
      <nav class="navbar navbar-expand-lg navbar-light">
        <div class="container">
          <div class="ON_inner_nav_container">
            <!-- Mobile display collapse -->
            <router-link class="navbar-brand ON_logo_lg" to="/">
              <img src="../assets/logo.png" width="162" height="60" alt="" />
            </router-link>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>

            <!-- navlink area -->

            <div
              class="collapse navbar-collapse offset"
              id="navbarSupportedContent"
              :style="navBarStyle"
            >
              <ul class="nav navbar-nav ON_main_menu_nav">
                <li class="nav-item">
                  <router-link
                    to="/"
                    class="nav-link"
                    v-scroll-to="{ el: '#topOfPage' }"
                    >Home</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    to="/blog"
                    class="nav-link"
                    v-scroll-to="{ el: '#topOfPage' }"
                    >Blog</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    to="/contact"
                    class="nav-link"
                    v-scroll-to="{ el: '#topOfPage' }"
                    >Contact</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    to="/help"
                    class="nav-link"
                    v-scroll-to="{ el: '#topOfPage' }"
                    >Help Center</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      navBarStyle: {
        backgroundColor: "#000000"
      }
    };
  },
  methods: {
    headerCurrentTime: function() {
      this.currentDate = moment().format("dddd, MMMM Do, YYYY");
    }
  },
  created() {
    this.headerCurrentTime();
  }
};
</script>
